var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('dv-scroll-board',{staticClass:"table",style:({height:(_vm.brandList.length===1 ? '100%':'95%')}),attrs:{"config":_vm.config},on:{"click":_vm.handleRowClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }